import SendNoteIcon from '@assets/icons/send-note.svg';
import { Analytics } from '@/utils/analytics';
import { createStyles } from '@/contexts/theme-context';
import { TouchableOpacity } from 'react-native';
import { TrackingData } from '@/utils/analytics/base-reporter';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useSupplierDynamicConfigValue } from '@/hooks/use-dynamic-config-value';

interface Props {
  notes: string;
  onPress: () => void;
  trackingData: TrackingData;
}

export const OrderItemNote: React.FC<Props> = ({
  notes,
  onPress,
  trackingData,
}) => {
  const [styles, theme] = useStyles();

  const isOrderNoteEnabled = useSupplierDynamicConfigValue(
    'line_item_notes_config',
  )?.enabled;

  if (!isOrderNoteEnabled) {
    return null;
  }

  return (
    <TouchableOpacity
      onPress={() => {
        if (trackingData) {
          Analytics.track(trackingData.name, trackingData.properties);
        }

        onPress();
      }}
      style={styles.notesContainer}
    >
      <SendNoteIcon
        height={16}
        stroke={theme.sk.color.icon.secondary}
        style={styles.icon}
        width={16}
      />
      <Typography flexShrink={1} numberOfLines={1} variant="paragraph-sm">
        {notes}
      </Typography>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  icon: {
    flexShrink: 0,
  },
  notesContainer: {
    alignItems: 'center',
    backgroundColor: theme.sk.color.bg.dsr,
    borderRadius: theme.sk.radii.radiusSmall,
    display: 'flex',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
    padding: theme.sk.spacing.spaceSmall,
  },
}));
